<div *hasScope="SCOPES.CANCELLATION_REASONS.READ_ALL" >

<div class="flex flex-col gap-4">
  <!-- filters -->
  <div class="rounded-2xl bg-white p-6 filters-shadow">
    <div class="mb-5 w-[320px]">
      <!--  two way binding  -->
      <app-filter-item-search [label]="searchLabel" [placeholder]="searchPlaceholder" [(searchTerm)]="search" />
    </div>


<div class="mb-6 grid grid-cols-4 gap-6">

  <div>
    <app-filter-date-component
      [label]="createdFromLabel"
      [(value)]="createdFrom"
    />

    @if (createdFromDateError()) {
      <p class="mt-1 text-sm text-red-500">
        {{ createdFromDateError() }}
      </p>
    }
  </div>

  <div>
    <app-filter-date-component
      [label]="createdToLabel"
      [(value)]="createdTo"
    />

    @if (createdToDateError()) {
      <p class="mt-1 text-sm text-red-500">
        {{ createdToDateError() }}
      </p>
    }
  </div>

  <div>
    <app-filter-date-component
      [label]="modifiedFromLabel"
      [(value)]="modifiedFrom"
    />

    @if (modifiedFromDateError()) {
      <p class="mt-1 text-sm text-red-500">
        {{ modifiedFromDateError() }}
      </p>
    }
  </div>

  <div>
    <app-filter-date-component
      [label]="modifiedToLabel"
      [(value)]="modifiedTo"
    />

    @if (modifiedToDateError()) {
      <p class="mt-1 text-sm text-red-500">
        {{ modifiedToDateError() }}
      </p>
    }
  </div>

</div>



    <hr class="mb-5 border-gray-200" />

    <div class="flex items-center justify-between">
      <app-filter-sorting-component
        [(orderBy)]="orderBy"
        [orderDir]="orderDir()"
        [sortOptions]="sortOptions"
        (toggleOrder)="toggleSortOrder()" />

      <div class="flex gap-3">
        <app-submit-button type="secondary" (click)="resetFilters()">
          <span i18n="@@cancellationReasonsReset">Clear</span>
        </app-submit-button>

        <app-submit-button type="primary" (click)="applyFilters()">
          <span i18n="@@cancellationReasonsApply">Apply</span>
        </app-submit-button>
      </div>
    </div>
  </div>

  <div class="rounded-2xl bg-white p-6 shadow-md">
    @if (loading()) {
      <div class="flex min-h-[300px] items-center justify-center">
        <app-loading />
      </div>
    } @else if (errorMessage()) {
      <app-error-data [title]="errorMessage()!" />
    } @else {
      @if (tableRows().length > 0) {
        <app-tables
          [headerItems]="headerItems()"
          [rows]="pagedRows()"
          [currentActions]="actions"
          (actionTrigger)="handleAction($event)" />

        <app-pagination
          [itemsPerPage]="itemsPerPage()"
          [currentPage]="currentPage()"
          [getPageNumbers]="getPageNumbers()"
          [totalPages]="totalPages()"
          [startItem]="startItem()"
          [endItem]="endItem()"
          [totalItems]="totalItems()"
          (previousPage)="onPreviousPage()"
          (nextPage)="onNextPage()"
          (goToPage)="onGoToPage($event)"
          (changePageNumber)="onChangePageNumber($event)"
          (pageSizeChange)="onPageSizeChange()" />
      } @else {
        <div class="flex flex-col items-center justify-center py-12 text-center">
          @if (search()) {
            <h3 class="text-lg font-semibold text-gray-700">
              <span i18n="@@cancellationReasonsNoSearchResults">No reasons match your search.</span>
            </h3>
          } @else if (createdFrom() || createdTo() || modifiedFrom() || modifiedTo()) {
            <h3 class="text-lg font-semibold text-gray-700">
              <span i18n="@@cancellationReasonsNoFilterResults">No reasons match your selected filters.</span>
            </h3>
          } @else {
            <h3 class="text-lg font-semibold text-gray-700">
              <span i18n="@@cancellationReasonsNoReasons">No cancellation reasons found.</span>
            </h3>
          }
        </div>
      }
    }
  </div>
</div>



</div>

<div *hasScope="SCOPES.CANCELLATION_REASONS.DELETE">
@if (showDeleteConfirmation()) {
  <app-confirmation-dialog
    [layout]="'start'"
    [title]="deleteTitle"
    [description]="deleteDescription"
    [confirmContent]="deleteButton()"
    [cancelContent]="cancelButton"
    [error]="deleteError()"
    (onSubmit)="confirmDelete()"
    (onCancel)="closeDeleteConfirmation()" />
}

@if (successMessage()) {
  <app-successful-notification type="success" [title]="successMessage()!" />
}

</div>
